import * as React from 'react';
import { is, Map } from 'immutable';

class BaseComponent<T, U> extends React.Component<T, U> {
  shouldComponentUpdate(nextProps: T, nextState: U) {
    const propsDiff = is(Map(nextProps), Map(this.props));
    const stateDiff = is(Map(nextState), Map(this.state));
    return !(propsDiff && stateDiff);
  }
}

export default BaseComponent;



// WEBPACK FOOTER //
// ./src/components/BaseComponent.tsx